export function useRoundable(props) {
  let roundableString;
  if (props.tile) {
    roundableString = null;
  } else if (props.roundedSmall) {
    roundableString = "rounded-sm";
  } else if (props.roundedLarge) {
    roundableString = "rounded-lg";
  } else if (props.roundedFull) {
    roundableString = "rounded-full";
  } else if ([false, "false", null, void 0].includes(props.rounded)) {
    roundableString = null;
  } else {
    roundableString = [true, "true", ""].includes(props.rounded) ? "rounded" : "rounded-" + props.rounded;
  }
  return {
    roundableString
  };
}
